export default __webpack_public_path__ + "static/media/a004-example1-en.ec49a18c.jpg";